import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById, putData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { MotorVariantForm } from "./components/motorVariantForm";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";

const EditMotorVariant = () => {

  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();
  const params = useParams();
  const paramId = params.id;

  const [variantData, setVariantData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/motor/mmv/variant/${paramId}`).then(
            (res) => {
              console.log(res);
              const responseData = res?.data;
              setVariantData((prevData) => ({
                ...prevData,
                name: responseData?.name,
                launchYear: {
                  label: responseData?.launchYear,
                  value: responseData?.launchYear,
                },
                vehicleCategory: {
                  label: responseData?.motorCategory?.keyName,
                  value: responseData?.motorCategory?.id,
                },
                motorModel: {
                  label: responseData?.motorModel?.name,
                  value: responseData?.motorModel?.id,
                },
                fuelType: {
                  label: responseData?.fuelType?.name,
                  value: responseData?.fuelType?.id,
                },
                engineCapacity: responseData?.engineCapacity,
                seatCapacity: responseData?.seatCapacity,
                carryingCapacity: responseData?.carryingCapacity,
                bodyType: {
                  label: responseData?.bodyType?.name,
                  value: responseData?.bodyType?.id,
                },
                bodyStyle: {
                  label: responseData?.bodyStyle?.name,
                  value: responseData?.bodyStyle?.id,
                },
                wheels: responseData?.wheels,
                iibCode: responseData?.iibCode,
                isActive: responseData?.isActive,

                //status update
                nameStatus: responseData?.name ? "success" : "undefined",
                launchYearStatus: responseData?.launchYear
                  ? "success"
                  : "undefined",
                vehicleCategoryStatus: responseData?.motorCategory?.id
                  ? "success"
                  : "undefined",
                motorModelStatus: responseData?.motorModel?.id
                  ? "success"
                  : "undefined",
                fuelTypeStatus: responseData?.fuelType?.id
                  ? "success"
                  : "undefined",
                engineCapacityStatus: responseData?.engineCapacity
                  ? "success"
                  : "undefined",
                seatCapacityStatus: responseData?.seatCapacity
                  ? "success"
                  : "undefined",
                carryingCapacityStatus: responseData?.carryingCapacity
                  ? "success"
                  : "undefined",
                bodyTypeStatus: responseData?.bodyType?.id
                  ? "success"
                  : "undefined",
                bodyStyleStatus: responseData?.bodyStyle?.id
                  ? "success"
                  : "undefined",
                wheelsStatus: responseData?.wheels ? "success" : "undefined",
                iibCodeStatus: responseData?.iibCode ? "success" : "undefined"
              }));
            }
          );
        } catch (error) {
          console.error("Error fetching data:",error);
          showSnackbar(error?.response?.data?.message, "error");
        } finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [paramId]);

  const handleUpdateVariant = async (variantData) => {
    setCircleLoading(true);
    const payload = {
      name: variantData?.name,
      motorCategoryId: variantData?.vehicleCategory?.value,
      motorModelId: variantData?.motorModelId,
      fuelTypeId: variantData?.fuelType?.value,
      bodyStyleId: variantData?.bodyStyle?.value,
      bodyTypeId: variantData?.bodyType?.value,
      engineCapacity: Number(variantData?.engineCapacity),
      seatCapacity: Number(variantData?.seatCapacity),
      carryingCapacity: Number(variantData?.carryingCapacity),
      iibCode: Number(variantData?.iibCode),
      wheels: Number(variantData?.wheels),
      launchYear: Number(variantData?.launchYear?.value),
      normalizedMmv: variantData?.normalizedMmv,
      isActive: variantData?.isActive,
    };
    try {
      const response = await putData(
        `/reference/motor/mmv/variant/${paramId}`,
        payload
      );
      if(response?.success){
        navigate("/motor-master/motor-MMV?tabState=variant");
        showSnackbar(response?.message,"success");
      }
    } catch (error) {
      console.error("Error Updating",error);
      showSnackbar(error?.response?.data?.message,"error");
    }
    finally{
      setCircleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Variant details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Variant Details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorVariantForm
            onsubmit={handleUpdateVariant}
            editVariantData={variantData}
          />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditMotorVariant;
